import AuthEndpoint from "./AuthEndpoint";
import CurrenciesEndpoint from "./CurrenciesEndpoint";
import DiscountsEndpoint from "./DiscountsEndpoint";
import SitesEndpoint from "./SitesEndpoint";
import UserEndpoint from "./UserEndpoint";
import OrderEndpoint from "./OrderEndpoint";
import NewsEndpoint from "./NewsEndpoint";
import PagesEndpoint from "./PagesEndpoint";
import BanerEndpoint from "./BanerEndpoint";
import StuffingEndpoint from "./StuffingEndpoint";
import BasketItemEndpoint from "./BasketItemEndpoint";
import BodyMailEndpoint from "./BodyMailEndpoint";

// import SectionsEndpoint from "./SectionsEndpoint";
// import FormsEndpoint from "./FormsEndpoint";

// import CartEndpoint from "./CartEndpoint";
// import ProductFeaturesEndpoint from "./ProductFeaturesEndpoint";
// import BasketEndpoint from "./BasketEndpoint";
// import RestaurantsEndpoint from "./RestaurantsEndpoint";
// import SearchEndpoint from "./SearchEndpoint";
// import MainEndpoint from "./MainEndpoint";
// import BookingEndpoint from "./BookingEndpoint";
// import FeedbackEndpoint from "./FeedbackEndpoint";

class Api {
    constructor(client) {
        client.proxy = {
            host: "admin.bypost.ru",
            port: 443,
        };
        this.client = client;

        this.auth = new AuthEndpoint(this.client);
        this.currencies = new CurrenciesEndpoint(this.client);
        this.discounts = new DiscountsEndpoint(this.client);
        this.sites = new SitesEndpoint(this.client);

        this.users = new UserEndpoint(this.client);
        this.orders = new OrderEndpoint(this.client);
        this.news = new NewsEndpoint(this.client);
        this.baners = new BanerEndpoint(this.client);
        this.stuffing = new StuffingEndpoint(this.client);
        this.pages = new PagesEndpoint(this.client);
        this.basketItems = new BasketItemEndpoint(this.client);
        this.bodymail = new BodyMailEndpoint(this.client);
    }
}

export default Api;
